export const cleanedEmailString = (email) => {
    return email.trim().toLowerCase();
};
